import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AccountServiceModule } from '../../services';
import { AccountSearchComponent } from './account-search.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    AccountServiceModule,
  ],
  declarations: [AccountSearchComponent],
  exports: [AccountSearchComponent],
})
export class AccountSearchComponentModule {}
